import React from "react";
import { Bar } from "react-chartjs-2";

const GrossSalesDiscountReport = ({
  chartData,
  chartOptions,
  storess,
  containerId,
  chartRef,
}) => (
  <div ref={chartRef} id={containerId}>
    <div className="card">
      <Bar data={chartData} options={chartOptions} />
    </div>

    <div className="print-only-content">
      <h2>Report Details</h2>
      <div className="print-only-content">
        <div>
          <h3>Brand: Angels Pizza</h3>
          <h3>Store: {storess}</h3>
        </div>
      </div>

      <div style={{ fontSize: "20px" }}>
        <table className="table text-center">
          <thead>
            <tr className="d-flex">
              <th>Month</th>
              <th className="ms-5">Gross Sales</th>
              <th className="ms-5">Discount Amount</th>
            </tr>
          </thead>
          <tbody>
            {chartData.labels.map((label, idx) => (
              <tr className="d-flex" key={`${containerId}-${idx}`}>
                <td>{label}</td>
                <td>{chartData.datasets[0].data[idx].toFixed(2)}</td>
                <td>{chartData.datasets[1].data[idx].toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default GrossSalesDiscountReport;
